// extracted by mini-css-extract-plugin
export default {"root":"styles_root__LbUfw","delete-button":"styles_delete-button__37Zdv","icon":"styles_icon__ZF2Dl"};